import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const StyledReactivateTrialDunningsSitewideBanner = styled(Flex)`
    background: ${colorsPalettes.blue[400]};
    padding: 8px 16px;
    gap: 16px;
    justify-content: center;
    align-items: center;
    height: 48px;
    box-shadow: 0 3px 5px 0 rgba(42, 62, 82, 0.12);
`;

export const ReactivateTrialBannerText = styled(Text)`
    font-weight: 400;
    line-height: 24px;
`;
